const imgRoute = "../static/drawer/";

const ORDERINVOICE_MENUS = [
  {
    menuName: "발주입고현황",
    img: `${imgRoute}발주입고현황.svg`,
    styleClass: "border-top-191E26",
    action: (bus, router, store) => {
      bus.$emit("loadingStart");
      bus.$emit("changeListGroup", "발주입고현황");
      router.push({ name: "OrderInvoice" }).catch(() => {
        bus.$emit("OrderInvoiceNavigationDuplicated");
        bus.$emit("loadingEnd");
      });
      store.commit("setFilter", null);
      bus.$emit("loadingEnd");
    },
  },
];
const INVOICE_MENUS = [
  {
    menuName: "출고현황",
    img: `${imgRoute}발주입고현황.svg`,
    action: (bus, router, store) => {
      bus.$emit("loadingStart");
      bus.$emit("changeListGroup", "출고현황");
      store.commit("setFilter", null);
      router.push({ name: "Invoice" }).catch(() => {
        bus.$emit("InvoiceNavigationDuplicated");
        bus.$emit("loadingEnd");
      });
      bus.$emit("loadingEnd");
    },
  },
];
const ORDER_MENUS = [
  {
    menuName: "발주현황",
    img: `${imgRoute}발주입고현황.svg`,
    action: (bus, router, store) => {
      bus.$emit("loadingStart");
      bus.$emit("changeListGroup", "발주현황");
      store.commit("setFilter", null);
      router.push({ name: "Order" }).catch(() => {
        bus.$emit("OrderNavigationDuplicated");
        bus.$emit("loadingEnd");
      });
      bus.$emit("loadingEnd");
    },
  },
];

const STORE_MENUS = [
  {
    menuName: "입고현황",
    img: `${imgRoute}발주입고현황.svg`,
    action: (bus, router, store) => {
      bus.$emit("loadingStart");
      bus.$emit("changeListGroup", "입고현황");
      store.commit("setFilter", null);
      router.push({ name: "Store" }).catch(() => {
        bus.$emit("OrderNavigationDuplicated");
        bus.$emit("loadingEnd");
      });
      bus.$emit("loadingEnd");
    },
  },
];
const ADMIN_MENU = [
  {
    menuName: "현장관리",
    img: `${imgRoute}현장관리.svg`,
    action: (bus, router, store) => {
      bus.$emit("loadingStart");
      bus.$emit("changeListGroup", "현장관리");
      store.commit("setFilter", null);
      router.push({ name: "Construction" }).catch(() => {
        bus.$emit("ConstructionNavigationDuplicated");
        bus.$emit("loadingEnd");
      });
      bus.$emit("loadingEnd");
    },
  },
  {
    menuName: "업체관리",
    img: `${imgRoute}업체관리.svg`,
    action: (bus, router, store) => {
      bus.$emit("loadingStart");
      bus.$emit("changeListGroup", "업체관리");
      store.commit("setFilter", null);
      router.push({ name: "Company" }).catch(() => {
        bus.$emit("CompanyNavigationDuplicated");
        bus.$emit("loadingEnd");
      });
      bus.$emit("loadingEnd");
    },
  },
  {
    menuName: "사용자관리",
    img: `${imgRoute}사용자관리.svg`,
    action: (bus, router, store) => {
      bus.$emit("loadingStart");
      bus.$emit("changeListGroup", "사용자관리");
      store.commit("setFilter", null);
      router.push({ name: "User" }).catch(() => {
        bus.$emit("UserNavigationDuplicated");
        bus.$emit("loadingEnd");
      });
      bus.$emit("loadingEnd");
    },
  },
];
const CONSTRUCTION_MENU = [
  {
    menuName: "현장선택",
    img: `${imgRoute}현장관리.svg`,
    action: (bus, router, store) => {
      bus.$emit("loadingStart");
      bus.$emit("changeListGroup", "현장선택");
      store.commit("setFilter", null);
      router.push({ name: "ChoiceCon" }).catch(() => {
        bus.$emit("ChoiceConNavigationDuplicated");
        bus.$emit("loadingEnd");
      });
      bus.$emit("loadingEnd");
      store.commit("resetStoreFilter");
    },
  },
];

const HISTORY_MENU = [
  {
    menuName: "승인/히스토리",
    img: `${imgRoute}history.svg`,
    action: (bus, router, store) => {
      bus.$emit("loadingStart");
      bus.$emit("changeListGroup", "승인/히스토리");
      store.commit("setFilter", null);
      router.push({ name: "Approval" }).catch(() => {
        bus.$emit("loadingEnd");
      });
      bus.$emit("loadingEnd");
    },
  },
];

const DASHBOARD_MENUS = [
  {
    menuName: "대시보드",
    img: `${imgRoute}발주입고현황.svg`,
    styleClass: "border-top-191E26",
    action: (bus, router, store) => {
      bus.$emit("loadingStart");
      bus.$emit("changeListGroup", "대시보드");
      store.commit("setFilter", null);
      router.push({ name: "DashBoard" }).catch(() => {});
      bus.$emit("loadingEnd");
    },
  },
];

export function makeMenuList(userAuth, constructionId) {
  let menu;
  if (constructionId) {
    if (userAuth === "뷰어") {
      return [
        ...DASHBOARD_MENUS,
        ...ORDERINVOICE_MENUS,
        ...ORDER_MENUS,
        ...INVOICE_MENUS,
        ...STORE_MENUS,
        ...CONSTRUCTION_MENU,
      ];
    }
    menu = ORDERINVOICE_MENUS.slice();
    menu.push(...ORDER_MENUS);
    if (userAuth == "시스템관리자" || userAuth == "현장관리자") {
      menu.unshift(...DASHBOARD_MENUS);
      menu.push(
        ...INVOICE_MENUS,
        ...STORE_MENUS,
        ...HISTORY_MENU,
        ...ADMIN_MENU,
        ...CONSTRUCTION_MENU
      );
    } else {
      menu.push(...INVOICE_MENUS, ...CONSTRUCTION_MENU);
    }
  } else {
    menu = [...ADMIN_MENU, ...CONSTRUCTION_MENU];
  }

  return menu;
}
